import { Avatar, List, Skeleton, Tag } from 'antd';
import shuffle from 'lodash/shuffle';
import React, { useEffect, useMemo, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { connect } from 'react-redux';
import { RouteComponentProps, RouteProps, withRouter } from 'react-router-dom';
import { Dispatch, compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import translations from 'translations';
import { ApplicationRootState } from 'types';
import generateProductSlug from 'utils/generateProductSlug';
import utilsMessages from 'utils/messages';
import * as qs from 'utils/queryString';
import {
  checkBadWord,
  deleteSearchHistory,
  saveSearchHistory,
  setSearchProductResults,
} from '../../containers/MainLayout/actions';
import makeSelectMainLayout, { selectSearchProductResults } from '../../containers/MainLayout/selectors';
import { MainLayoutState } from '../../containers/MainLayout/types';
import { FrameImage } from '../Product/ProductImagesModal';
import SVGIcon from '../SVGIcon/SVGIcon';
import message from './messages';
import TrashIcon from './TrashIcon.svg';
import TrendingFire from './trendingFire.png';
import { generateUrlBrandDetail } from 'utils/generateBrandDetailUrl';
import { generateSlugFromID } from 'utils/urls/categoriesPathSegment';
import subCategoriesImage from './SubCateImg';

interface IProps {
  keyword: string;
  onCloseDropdown: () => void;
}

interface StateProps {
  searchResultList: any;
  mainLayout: MainLayoutState;
}

interface IDispatchProps {
  setSearchProductResults: (payload: any) => void;
  handleSaveSearchKeyword: (keyword: string) => void;
  handleDeleteAllSearchKeyword: () => void;
  checkBadword: (params: { keyword: string; cb: () => void }) => void;
}
type Props = IDispatchProps & IProps & StateProps & RouteComponentProps & RouteProps;

const SearchWithDropDownContainer = styled.div`
  border-radius: 7px;
  background: #ffffff;
  position: absolute;
  top: 63px;
  width: 100%;
  max-height: 400px;
  overflow: auto;
  padding: 16px;
  box-shadow: 0px 2px 7.3px 0px rgba(0, 0, 0, 0.2);
  .ant-list-item {
    border-radius: 6px;
    cursor: pointer;
    .ant-list-item-meta-title {
      font-weight: 400;
      color: #424242 !important;
      margin-bottom: 0px !important;
    }
    .ant-list-item-meta {
      margin: 0 4px;
      align-items: center;
    }
  }
  .ant-list-item:hover {
    background: #f1f1f1;
  }
  @media (min-width: 1024px) {
    width: 600px;
  }
  @media (max-width: 767px) {
    top: 45px;
  }
`;

const PopularSearch = styled.div`
  border-radius: 7px;
  background: #ffffff;
  position: absolute;
  top: 63px;
  padding: 16px;
  box-shadow: 0px 2px 7.3px 0px rgba(0, 0, 0, 0.2);
  width: 100%;
  .ant-list-item {
    border-radius: 6px;
    cursor: pointer;
    .ant-list-item-meta-title {
      font-weight: 400;
      color: #424242 !important;
      margin-bottom: 0px !important;
    }
    .ant-list-item-meta {
      margin: 0 4px;
      align-items: center;
    }
  }
  .ant-list-item:hover {
    background: #f1f1f1;
  }
  @media (max-width: 767px) {
    top: 45px;
  }
  @media (min-width: 1024px) {
    width: 600px;
  }
`;

const PopularSearchTitle = styled.h2`
  color: #242527;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 12px;
`;

const PopularSearchList = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 138px);
  gap: 8px;
  @media (max-width: 992px) {
    width: 100%;
    overflow-x: auto;
  }
`;
const PopularTag = styled(Tag)`
  white-space: break-spaces;
  padding: 4px;
  margin: 0;
  font-size: 13px;
  line-height: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  font-weight: 400;
  &:hover {
    color: #4b9c63;
    border-color: #4b9c63;
  }
`;
const SubCatText = styled.div``;
const SubCatImg = styled(Avatar)`
  flex-shrink: 0;
`;

const ImageWrapper = styled.div`
  position: relative;
  border-radius: 6px;
  overflow: hidden;
`;

const SearchKeywordsContainer = styled.div`
  margin-bottom: 20px;
`;

const SearchKeywordsTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  ${({ noSpace }) =>
    noSpace &&
    `
    justify-content: unset;
    gap: 2px;
  `}
`;

const SearchKeywordsTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #242527;
`;

const TrendingFireImage = styled.img`
  width: 18px;
  height: 18px;
  object-fit: cover;
`;

const SearchKeywordsList = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

const SearchKeywordsItem = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: #343538;
  padding: 5px 12px;
  border: 1px solid #d5d7d5;
  border-radius: 20px;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
`;

const SearchKeywordsIcon = styled(SVGIcon)`
  cursor: pointer;
  &:hover {
    opacity: 0.6;
  }
`;

const TrendingSquareContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(50px, 132px));
  gap: 12px;
`;

const TrendingSquareItem = styled.div`
  border-radius: 4px;
  cursor: pointer;
`;

const TrendingSquareImg = styled.div`
  background-image: ${({ imgUrl }) =>
    imgUrl
      ? `url("${imgUrl}")`
      : 'url("https://image-handler-prod.s3.ap-southeast-1.amazonaws.com/supplier/654/LOGO/place-holder-product.png")'};
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 97.16%;
  border: 1px solid #eaeaeb;
  width: 100%;
  height: 100%;
  border-radius: 4px;
`;

const TrendingSquareText = styled.span`
  display: block;
  font-size: 14px;
  color: #424242;
  text-align: center;
  margin-top: 8px;
  max-width: 80px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  media(max-width: 767px) {
    font-size: 12px;
  }
`;

export const SEARCH_HISTORY_KEY = 'searchHistory';

const checkingKeywords = new Set<string>();

const SearchWithDropDown: React.FC<Props> = (props) => {
  const {
    keyword,
    setSearchProductResults,
    onCloseDropdown,
    searchResultList,
    location,
    history,
    mainLayout: { trendingSearchData, searchHistory, recommendSkusForLoggedInUser, buyer, categories },
    handleSaveSearchKeyword,
    handleDeleteAllSearchKeyword,
    checkBadword,
  } = props;
  const loggedIn = !!localStorage.getItem('token');
  const [keywordsSearch, setKeywordsSearch] = useState(
    JSON.parse(localStorage.getItem(SEARCH_HISTORY_KEY)?.toString() || '[]'),
  );
  const lang = localStorage.getItem('lang') || 'vi';
  const frameTagImage = (item) => (lang === 'vi' ? item.tagImageVn : item.tagImageEn || '');

  const loadMoreData = () => {
    if (searchResultList.loading) {
      return;
    }
    const query = qs.parse(location.search);
    setSearchProductResults({
      query: {
        filter: {
          query: keyword,
          categoryName: query?.filter?.categoryName,
        },
      },
      clearPreviousData: false,
    });
  };

  const popularSearchData = useMemo(() => {
    if (!categories?.length) return [];
    const subCategory = categories.reduce((acc, item) => {
      const subCategories = item.children.reduce((acc, subCat) => {
        if (!subCat.name.includes('Other')) {
          return [...acc, subCat];
        }
        return acc;
      }, []);
      return [...acc, ...subCategories];
    }, []);
    const result = shuffle(subCategory);
    return result.slice(0, 8).map((item) => ({
      ...item,
      nameImg: item.name.split('/')[1].replace(/[ &]/g, ''),
    }));
  }, [categories]);

  const recentSearchKeywordsData = useMemo(() => {
    if (!loggedIn) {
      return keywordsSearch || [];
    }
    return searchHistory?.map((item) => item.keyword);
  }, [keywordsSearch, loggedIn, searchHistory]);

  const isShowPopularData = useMemo(() => {
    const hasTrendingSearchData = Object.values(trendingSearchData).some((vl) => vl?.length);
    return !loggedIn && !recentSearchKeywordsData?.length && !hasTrendingSearchData;
  }, [recentSearchKeywordsData, trendingSearchData, loggedIn]);

  const handleSaveKeywordSearch = (keyword) => {
    const cleanKeyword = keyword.trim().toLowerCase();
    const detectRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b|(?:\+84|0)(?:\d{9,10})|\b\d{4,8}\b/i; // check phone number, otp, email
    if (!cleanKeyword || detectRegex.test(cleanKeyword)) return;
    if (!loggedIn) {
      const currentHistory = JSON.parse(localStorage.getItem(SEARCH_HISTORY_KEY)?.toString() || '[]');
      if (
        !currentHistory.includes(cleanKeyword) &&
        !keywordsSearch.includes(cleanKeyword) &&
        !checkingKeywords.has(cleanKeyword)
      ) {
        checkingKeywords.add(cleanKeyword);
        checkBadword({
          keyword: cleanKeyword,
          cb: () => {
            setKeywordsSearch((preValue) => {
              const updatedValue = [...preValue];
              updatedValue.unshift(cleanKeyword);
              const newValue = updatedValue.slice(0, 5);
              localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(newValue));
              checkingKeywords.delete(cleanKeyword);
              return newValue;
            });
          },
        });
      }
    } else {
      handleSaveSearchKeyword(cleanKeyword);
    }
  };

  const handleDeleteKeywordsSearch = () => {
    if (!loggedIn) {
      localStorage.removeItem(SEARCH_HISTORY_KEY);
      setKeywordsSearch([]);
    } else {
      handleDeleteAllSearchKeyword();
    }
  };

  const handleClickKeyword = (keyword: string) => {
    const searchParams = qs.stringify({
      q: keyword || undefined,
      favorite: undefined,
    });
    history.push({
      pathname: `/market`,
      search: searchParams,
    });
    onCloseDropdown();
  };

  useEffect(() => {
    const query = qs.parse(location.search);
    if (query && keyword && !searchResultList?.data?.length) {
      setSearchProductResults({
        query: query,
        clearPreviousData: true,
      });
    }
  }, []);
  if (!keyword && !searchResultList.data.length) {
    return (
      <>
        <PopularSearch>
          {isShowPopularData && (
            <>
              <PopularSearchTitle>{translations(message.popularSearches)}</PopularSearchTitle>
              <PopularSearchList>
                {popularSearchData.map((item) => (
                  <>
                    <PopularTag
                      key={item.name}
                      color={item.color}
                      onClick={() => {
                        history.push(`/${generateSlugFromID(item, lang)}`);
                        onCloseDropdown();
                      }}
                    >
                      <SubCatImg
                        shape="square"
                        size={40}
                        src={<img src={subCategoriesImage[item.id]} alt={`Icon-${item.nameImg}`} loading="lazy" />}
                      />
                      <SubCatText>{item.nameLocal}</SubCatText>
                    </PopularTag>
                  </>
                ))}
              </PopularSearchList>
            </>
          )}
          {!!recentSearchKeywordsData.length && (
            <SearchKeywordsContainer>
              <SearchKeywordsTitleContainer>
                <SearchKeywordsTitle>{translations(message.recentSearches)}</SearchKeywordsTitle>
                <SearchKeywordsIcon src={TrashIcon} onClick={handleDeleteKeywordsSearch} />
              </SearchKeywordsTitleContainer>
              <SearchKeywordsList>
                {recentSearchKeywordsData.map((item) => (
                  <SearchKeywordsItem key={item} onClick={() => handleClickKeyword(item)}>
                    {item}
                  </SearchKeywordsItem>
                ))}
              </SearchKeywordsList>
            </SearchKeywordsContainer>
          )}
          {!!trendingSearchData?.trendingKeywords?.length && (
            <SearchKeywordsContainer>
              <SearchKeywordsTitleContainer noSpace>
                <SearchKeywordsTitle>{translations(message.popularSearchesTitle)}</SearchKeywordsTitle>
                <TrendingFireImage src={TrendingFire} />
              </SearchKeywordsTitleContainer>
              <SearchKeywordsList>
                {trendingSearchData?.trendingKeywords?.map((item) => (
                  <SearchKeywordsItem key={item} onClick={() => handleClickKeyword(item || '')}>
                    {item}
                  </SearchKeywordsItem>
                ))}
              </SearchKeywordsList>
            </SearchKeywordsContainer>
          )}
          {!!trendingSearchData?.trendingProductSubCate?.length && (
            <div style={{ marginBottom: '16px' }}>
              <SearchKeywordsTitleContainer>
                <SearchKeywordsTitle>{translations(message.trending)}</SearchKeywordsTitle>
              </SearchKeywordsTitleContainer>
              <TrendingSquareContainer>
                {trendingSearchData?.trendingProductSubCate?.map((item) => (
                  <div
                    key={item?.refId}
                    onClick={() =>
                      history.push(
                        `${generateSlugFromID({ parent: { nameLocal: item?.category?.parentNameLocal || '' }, nameLocal: item?.refName, id: item?.refId } as any, lang)}`,
                      )
                    }
                  >
                    <TrendingSquareItem>
                      <TrendingSquareImg imgUrl={item?.refImage} />
                    </TrendingSquareItem>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <TrendingSquareText>{item?.refName}</TrendingSquareText>
                    </div>
                  </div>
                ))}
              </TrendingSquareContainer>
            </div>
          )}
          {!!trendingSearchData?.trendingProductBrand?.length && (
            <>
              <SearchKeywordsTitleContainer>
                <SearchKeywordsTitle>{translations(message.trustedBrands)}</SearchKeywordsTitle>
              </SearchKeywordsTitleContainer>
              <TrendingSquareContainer>
                {trendingSearchData?.trendingProductBrand?.map((item) => (
                  <div
                    key={item?.refId}
                    onClick={() =>
                      history.push(
                        `${generateUrlBrandDetail(String(item?.brand?.id) || '', item?.brand?.name || '', lang)}`,
                      )
                    }
                  >
                    <TrendingSquareItem>
                      <TrendingSquareImg imgUrl={item?.refImage} />
                    </TrendingSquareItem>
                  </div>
                ))}
              </TrendingSquareContainer>
            </>
          )}
          {!!recommendSkusForLoggedInUser?.length && loggedIn && (
            <>
              <SearchKeywordsTitleContainer>
                <SearchKeywordsTitle>{`${lang === 'vi' ? 'Gợi ý cho' : 'Recommended for'} ${utilsMessages?.[buyer?.businessCategory || ''] ? translations(utilsMessages?.[buyer?.businessCategory || '']) : lang === 'vi' ? 'bạn' : 'you'}`}</SearchKeywordsTitle>
              </SearchKeywordsTitleContainer>
              <List
                dataSource={recommendSkusForLoggedInUser}
                renderItem={(item: any) => (
                  <List.Item
                    key={item.id}
                    onClick={() => {
                      handleSaveKeywordSearch(keyword);
                      history.push(`/products/${generateProductSlug(item.name, item.supplierInternalCode, lang)}`);
                      onCloseDropdown();
                    }}
                  >
                    <List.Item.Meta
                      avatar={
                        <ImageWrapper>
                          <Avatar shape="square" size={40} src={item.imageUrl} />
                          {frameTagImage(item) && <FrameImage src={frameTagImage(item)} />}
                        </ImageWrapper>
                      }
                      title={item.name}
                    />
                  </List.Item>
                )}
                split={false}
                loading={searchResultList.loading}
              />
            </>
          )}
        </PopularSearch>
      </>
    );
  }
  return (
    <SearchWithDropDownContainer id="scrollableDiv">
      <InfiniteScroll
        dataLength={searchResultList.data.length}
        next={loadMoreData}
        hasMore={searchResultList.data.length < searchResultList.totalResults}
        loader={<Skeleton avatar={{ shape: 'square' }} paragraph={{ rows: 0 }} title={{ width: '100%' }} active />}
        scrollableTarget="scrollableDiv"
      >
        <List
          dataSource={searchResultList.data}
          renderItem={(item: any) => (
            <List.Item
              key={item.id}
              onClick={() => {
                handleSaveKeywordSearch(keyword);
                history.push(`/products/${generateProductSlug(item.name, item.supplierInternalCode, lang)}`);
                onCloseDropdown();
              }}
            >
              <List.Item.Meta
                avatar={
                  <ImageWrapper>
                    <Avatar shape="square" size={40} src={item.imageUrl} />
                    {frameTagImage(item) && <FrameImage src={frameTagImage(item)} />}
                  </ImageWrapper>
                }
                title={item.name}
              />
            </List.Item>
          )}
          split={false}
          loading={searchResultList.loading}
        />
      </InfiniteScroll>
    </SearchWithDropDownContainer>
  );
};
const mapStateToProps = createStructuredSelector<ApplicationRootState, StateProps>({
  searchResultList: selectSearchProductResults(),
  mainLayout: makeSelectMainLayout(),
});
const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => {
  return {
    setSearchProductResults: (payload: any) => {
      dispatch(setSearchProductResults.request(payload));
    },
    handleSaveSearchKeyword: (keyword: string) => {
      dispatch(saveSearchHistory(keyword));
    },
    handleDeleteAllSearchKeyword: () => {
      dispatch(deleteSearchHistory());
    },
    checkBadword: (params: { keyword: string; cb: () => void }) => {
      dispatch(checkBadWord(params));
    },
  };
};
export default compose(
  connect((state) => state),
  connect(mapStateToProps, mapDispatchToProps),
)(withRouter(SearchWithDropDown));
